// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"50ac817a","223":"c228530c","239":"29fdec28","453":"574dc94a","455":"20b84ab9"}[chunkId] + ".chunk.js";
};